// src/components/Home/ContactSection.jsx
import React from 'react';
import './ContactSection.css';

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

const WebIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const LocationIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const contactItems = [
  {
    id: 'phone',
    icon: PhoneIcon,
    label: 'Phone',
    content: (
      <>
        <a href="tel:+2347032941519" className="contact-link">+234 703 294 1519</a>
        <a href="tel:+2348142638552" className="contact-link">+234 814 263 8552</a>
      </>
    ),
  },
  {
    id: 'email',
    icon: EmailIcon,
    label: 'Email',
    content: (
      <a href="mailto:aicisnigeria@abvig.org" className="contact-link">aicisnigeria@abvig.org</a>
    ),
  },
  {
    id: 'website',
    icon: WebIcon,
    label: 'Website',
    content: (
      <a href="https://abvig.com" target="_blank" rel="noopener noreferrer" className="contact-link">
        www.abvig.com
      </a>
    ),
  },
  {
    id: 'location',
    icon: LocationIcon,
    label: 'Location',
    content: <p className="contact-text">Abuja, Nigeria</p>,
  },
];

const ContactSection = () => {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-header">
          <span className="contact-badge">GET IN TOUCH</span>
          <h2 className="contact-title">Contact Us</h2>
          <div className="contact-title-line" />
          <p className="contact-subtitle">
            Have questions about AICIC 2026? Reach the summit secretariat directly — we are ready to assist with registration, sponsorship, and general inquiries.
          </p>
        </div>

        <div className="contact-grid">
          {contactItems.map(({ id, icon: Icon, label, content }) => (
            <article className="contact-card" key={id}>
              <div className="contact-icon-wrap">
                <Icon />
              </div>
              <h3 className="contact-card-label">{label}</h3>
              <div className="contact-card-body">{content}</div>
            </article>
          ))}
        </div>

        <div className="contact-cta">
          <p className="contact-cta-text">Need a quick response? Call or email the team today.</p>
          <div className="contact-cta-actions">
            <a href="tel:+2347032941519" className="contact-cta-btn contact-cta-btn--primary">
              Call Now
            </a>
            <a href="mailto:aicisnigeria@abvig.org" className="contact-cta-btn contact-cta-btn--secondary">
              Send Email
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;